import { Link } from "react-router-dom";
import MainContent4 from "../MainContent4";
import AsideContent2 from "../AsideContent2";
import GoToTop from "../GoToTop";
import ResourcesList from "../assets/ResourcesList";



const GreatQuotesPage = () => {
    return (
        <div className="content">
            <main>
                <MainContent4 resource={ResourcesList} />
                <h2 className="back"><Link to="/GreatQuotes" title="Back to Top" className="backLink link">- BACK To TOP -</Link></h2>
            </main>
            <aside>
                <AsideContent2 resource={ResourcesList}/>
            </aside>
            <GoToTop />
  	    </div>
    );
};
export default GreatQuotesPage;